<template>
    <div class="content guest">
        <router-view></router-view>
    </div>
</template>

<script>
export default {
    mounted() {
        //
    },
}
</script>
